module.exports = __webpack_public_path__ + "static/media/19ESCAP6.530d4ff0.jpg";